import { styled } from '@grupoboticario/flora-react';

export const Picture = {
  Wrapper: styled('picture', {
    img: {
      maxHeight: '100%',
      objectFit: 'cover',
    },
  }),
};
